import ds from './DataSourceService'

const baseUrl = '/projects'

const getProjects = () => {
  return ds.apiClientThinkHome.get(baseUrl + '?include[]=Media')
}

const getProjectById = id => {
  return ds.apiClientThinkHome.get(baseUrl + '/' + id)
}

const getProjectMasterplans = id => {
  return ds.apiClientThinkHome.get(baseUrl + '/' + id + '/masterplans')
}
const getProjectBuildings = id => {
  return ds.apiClientThinkHome.get(baseUrl + '/' + id + '/buildings')
}
const getProjectApartments = (id, queryParams = {}) => {
  return ds.apiClientThinkHome.get(baseUrl + '/' + id + '/apartments', {
    params: queryParams
  })
}
const getProjectPackages = id => {
  return ds.apiClientThinkHome.get(baseUrl + '/' + id + '/packages')
}

const createProject = data => {
  return ds.apiClientThinkHome.post(baseUrl, data)
}

const updateProject = data => {
  return ds.apiClientThinkHome.patch(baseUrl + '/' + data.id, data)
}

const uploadLogo = (id, tempFileName, logoBaseUrl) => {
  return ds.apiClientThinkHome.post(baseUrl + '/' + id + '/logo', {
    tempFileName,
    baseUrl: logoBaseUrl
  })
}

const deleteProject = (projectId, value) => {
  return ds.apiClientThinkHome.delete(baseUrl + '/' + projectId, {
    data: { anonymize: value }
  })
}

const getExportedProject = data => {
  return ds.apiClientThinkHome.get(`${baseUrl}/${data.id}/full-structure`, data)
}

const importProject = data => {
  return ds.apiClientThinkHome.post(`${baseUrl}/import`, data)
}

const getProjectSettings = data => {
  return ds.apiClientThinkHome.get(`${baseUrl}/${data}/settings`)
}

const setProjectSettings = data => {
  return ds.apiClientThinkHome.post(
    `${baseUrl}/${data.projectId}/settings`,
    data
  )
}

const setTitleImage = (id, mediaId) => {
  return ds.apiClientThinkHome.post(
    baseUrl + `/${id}/media-content/${mediaId}/set-title-image`,
    {}
  )
}

// MEDIA

const getProjectMedia = (id, params) => {
  return ds.apiClientThinkHome.get(baseUrl + '/' + id + '/media-content', {
    params
  })
}

const getProjectTitleImage = (id, params) => {
  return ds.apiClientThinkHome.get(baseUrl + '/' + id + '/title-image', {
    params
  })
}

const getMediaManagerMedia = id => {
  return ds.apiClientThinkHome.get(`/media-manager/${id}`)
}

const createProjectMedia = (id, media) => {
  return ds.apiClientThinkHome.post(
    baseUrl + '/' + id + '/media-content',
    media
  )
}
const updateProjectMedia = (id, media) => {
  return ds.apiClientThinkHome.patch(
    baseUrl + '/' + id + '/media-content',
    media
  )
}

const deleteProjectMedia = (id, mediaId) => {
  return ds.apiClientThinkHome.delete(baseUrl + '/' + id + '/media-content', {
    data: { mediaId: mediaId }
  })
}

const getProjectFullStructure = id => {
  return ds.apiClientThinkHome.get(baseUrl + '/' + id + '/full-structure')
}

const getProjectReservations = id => {
  return ds.apiClientThinkHome.get(baseUrl + '/' + id + '/reservations')
}

const getUsersOnProject = id => {
  return ds.apiClientThinkHome.get(baseUrl + '/' + id + '/get-all-users')
}

export default {
  getProjects,
  getProjectById,
  getProjectMasterplans,
  getProjectPackages,
  updateProject,
  uploadLogo,
  getProjectMedia,
  getProjectBuildings,
  getProjectApartments,
  createProjectMedia,
  updateProjectMedia,
  deleteProjectMedia,
  getProjectFullStructure,
  getProjectReservations,
  getExportedProject,
  importProject,
  getUsersOnProject,
  deleteProject,
  createProject,
  getMediaManagerMedia,
  getProjectSettings,
  setProjectSettings,
  setTitleImage,
  getProjectTitleImage
}
